import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-content-tab-list',
    templateUrl: './categorize-tab-list.component.html',
    styleUrls: ['./categorize-tab-list.component.css'],
    standalone: false
})
export class CategorizeTabListComponent implements OnInit {

  @Input() activeTab = 0;
  @Input() category = '';
  @Input() type = '';

  tabOptions = {
    management:
      [
        {label: 'Super categories', link: '/super-categories'},
        {label: 'Categories', link: '/categories'},
        {label: 'Memberships', link: '/memberships'},
        {label: 'Rating categories', link: '/rating-categories'},
        {label: 'Score models', link: '/management/score-models'},
      ],
    cms:
      [
        {label: 'Banners', link: '/banners'},
        {label: 'Icons', link: '/icons'},
        {label: 'NFTs', link: '/nfts-collection'},
        {label: 'Hindutva laboratory', link: '/cms/hindutva-laboratory'},
      ],
    communication: [
      {label: 'News', link: '/news'},
      {label: 'Suggestions', link: '/suggestions'},
    ],
    user: [
      {label: 'Users', link: '/users'},
      {label: 'Organizations', link: '/organizations'},
      {label: 'Quotes', link: '/quotes'},
      {label: 'Claim requests', link: '/claim'},
      {label: 'Podcasts', link: '/podcasts'},
      {label: 'User funding', link: '/users/user-funding'},
    ],
    marketplace: [
      {label: 'Books', link: '/marketplace/books'},
      {label: 'Projects', link: '/marketplace/projects'},
      {label: 'Satire', link: '/marketplace/satire'},
      {label: 'Requests', link: '/marketplace/requests'},
    ],
    import: [
      {label: 'Import users', link: '/import/import-users'},
      {label: 'Import entities', link: '/import/import-entities'},
      {label: 'Import ratings', link: '/import/import-ratings'},
      {label: 'Import entity lookup', link: '/import/import-entity-lookup'},
      {label: 'Import demographic clock cities', link: '/import/import-demographic-clock-cities'},
    ]
  };

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  changeRoute(index: any = ''): void {
    this.router.navigate([this.tabOptions[this.type][index].link]);
  }
}
